import APIKeysTable from "@/components/api-keys-table";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { Key, Plus } from "lucide-react";

export default function APIKeysManagement({ apiKeys }: { apiKeys: any[] }) {

  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
          <div>
            <CardTitle>API Keys</CardTitle>
            <CardDescription>
              Manage your API keys
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {apiKeys.length === 0 ? (
          <div className="text-center py-8">
            <Key className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              No API keys yet
            </h3>
            <p className="text-gray-500 mb-4">
              Subscribe to a plan to get your API key
            </p>
            <Button asChild>
              <Link to="/dashboard/billing">
                <Plus className="w-4 h-4 mr-2" />
                Choose Plan
              </Link>
            </Button>
          </div>
        ) : (
          <APIKeysTable apiKeys={apiKeys} />
        )}
      </CardContent>
    </Card>
  );
}
